.root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-deep);
  padding: 24px;
}

.card {
  width: 100%;
  max-width: 360px;
  background: var(--card);
  border: 1px solid var(--line2);
  border-radius: 12px;
  padding: 28px 26px 26px;
}

.logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--g);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--on-accent);
  font: 700 15px 'IBM Plex Mono', monospace;
  margin-bottom: 10px;
}

.title {
  font: 600 17px/1.2 'IBM Plex Sans', sans-serif;
  letter-spacing: -0.01em;
  color: var(--t0);
}

.subtitle {
  font: 400 11px/1.2 'IBM Plex Mono', monospace;
  color: var(--t8);
}

.error {
  font: 500 11.5px/1.4 'IBM Plex Sans', sans-serif;
  color: var(--r-txt);
  background: var(--r16);
  border: 1px solid var(--r50);
  border-radius: 7px;
  padding: 8px 10px;
}
